/**
 *
 * @param url
 * @param type
 * @param data
 * @param cache
 * @param token
 * @returns {Promise<{getAllResponseHeaders: function(): *|null, abort: function(*=): this, setRequestHeader: function(*=, *): this, readyState: number, getResponseHeader: function(*): null|*, overrideMimeType: function(*): this, statusCode: function(*=): this}|*|jQuery>}
 */
export async function performHttpRequest(url,
                                         type,
                                         data = null,
                                         cache = false,
                                         token = false) {

    if(type === 'POST') {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(data)
        };

        return fetch(url, requestOptions)
    }

    return new Promise(function (resolve, reject) {
        const Http = new XMLHttpRequest();
        Http.open(type, url);
        Http.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");

        Http.onload = function () {
            if (Http.status >= 200 && Http.status < 300) {
                resolve(JSON.parse(Http.response));
            } else {
                reject({
                    status: Http.status,
                    statusText: Http.statusText
                });
            }
        };
        Http.onerror = function () {
            reject({
                status: Httpstatus,
                statusText: Http.statusText
            });
        };
        Http.send(serialize(data));
    })
}

export function serialize(obj) {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    return str.join("&");
}
